import flatten from 'lodash/flatten';

import {ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {SelectorType, SelectorTypeDefinitions} from 'common/widgets/query-entry-section/types';

import {Action, EntryType} from './types';

export type ResourceTrackingTypes = SelectorType | EntryType;

const BaseTracking = {
  [Action.AddFilter]: `Add event filter`,
  [Action.EditFilter]: `Edit event filter`,
  [Action.RemoveFilter]: `Remove event filter`,
};

export const ResourceTrackingEvent: {[s in ResourceTrackingTypes]?: {[key in Action]?: string}} = {
  [ResourceType.Cohort]: {
    ...BaseTracking,
    [Action.Add]: `Add cohort`,
    [Action.Clone]: `Clone cohort`,
    [Action.Drag]: `Drag a cohort`,
    [Action.Remove]: `Remove cohort`,
    [Action.Select]: `Select cohort`,
  },
  [ResourceType.Event]: {
    ...BaseTracking,
    [Action.Add]: `Add event`,
    [Action.Clone]: `Clone event`,
    [Action.Drag]: `Drag an event`,
    [Action.Remove]: `Remove event`,
    [Action.Select]: `Select event`,
    [Action.Group]: `Add event comparison`,
    [Action.Ungroup]: `Remove event comparison`,
  },
  [SelectorTypeDefinitions.FlowsEvent]: {
    ...BaseTracking,
    [Action.Add]: `Add event`,
    [Action.Clone]: `Clone event`,
    [Action.Drag]: `Drag an event`,
    [Action.Remove]: `Remove event`,
    [Action.Select]: `Select event`,
    [Action.EditFlowSteps]: `Edit Flow Steps`,
  },
  [SelectorTypeDefinitions.EventPropertyAggregation]: {
    [Action.Add]: `Add aggregation`,
    [Action.Clone]: `Clone aggregation`,
    [Action.Drag]: `Drag aggregation`,
    [Action.Remove]: `Remove aggregation`,
    [Action.Select]: `Select aggregation event`,
  },
  [SelectorTypeDefinitions.UserPropertyAggregation]: {
    [Action.Add]: `Add user aggregation`,
    [Action.Clone]: `Clone user aggregation`,
    [Action.Drag]: `Drag user aggregation`,
    [Action.Remove]: `Remove user aggregation`,
    [Action.Select]: `Select user aggregation`,
  },
  [ResourceType.User]: {
    [Action.Add]: `Add user group`,
    [Action.Clone]: `Clone user group`,
    [Action.Drag]: `Drag user group`,
    [Action.Remove]: `Remove user group`,
    [Action.Select]: `Select user group`,
  },
  [SelectorTypeDefinitions.Filter]: {
    [Action.Add]: `Add property filter`,
    [Action.Clone]: `Clone property filter`,
    [Action.Drag]: `Drag a property filter`,
    [Action.Edit]: `Edit property filter`,
    [Action.Remove]: `Remove property filter`,
  },
  [SelectorTypeDefinitions.Segment]: {
    [Action.Add]: `Add segment`,
    [Action.Clone]: `Clone segment`,
    [Action.Drag]: `Reorder segment`,
    [Action.Edit]: `Edit segment`,
    [Action.Remove]: `Remove segment`,
  },
  [SelectorTypeDefinitions.Behavior]: {
    [Action.Add]: `Add behavior`,
    [Action.Clone]: `Clone behavior`,
    [Action.Drag]: `Drag a behavior`,
    [Action.Remove]: `Remove behavior`,
    [Action.Select]: `Select behavior`,
  },
  [SelectorTypeDefinitions.EventLaunch]: {
    [Action.Add]: `Add event`,
    [Action.Clone]: `Clone event`,
    [Action.Drag]: `Drag an event`,
    [Action.Remove]: `Remove event`,
    [Action.Select]: `Select event`,
    [Action.SelectDateRange]: `Select date range`,
  },
  [EntryType.ExclusionEvent]: {
    [Action.Add]: `Add exclusion step`,
    [Action.AddFilter]: `Add exclusion step filter`,
    [Action.Clone]: `Clone exclusion step`,
    [Action.EditFilter]: `Edit exclusion step filter`,
    [Action.Remove]: `Remove exclusion step`,
    [Action.RemoveFilter]: `Remove exclusion step filter`,
    [Action.Select]: `Select exclusion step`,
  },
};

export const FlattenedResourceTrackingEvent = flatten(
  Object.values(ResourceTrackingEvent).map((entry) => Object.values(entry)),
);

export enum TrackingEvent {
  EditExclusionStepRange = `Edit exclusion step range`,
  EventIndexLabelClicked = `Event index label clicked`,
  RenameEvent = `Rename event`,
  ClearNumericProperty = `Clear numeric property`,
  SelectNumericAggregator = `Select numeric aggregator`,
  SelectNumericProperty = `Select numeric property`,
  OpenCustomBucketPane = `Open custom bucket pane`,
  ResetCustomBucket = `Reset custom bucket`,
  ApplyCustomBucket = `Apply custom bucket`,
}
